export enum FlyoutButtonSize {
	Auto = 'auto',
	Tiny = 'tiny',
	Small = 'small',
	Large = 'large',
}
